// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oXHT","textarea":"styles_textarea__2fuAW"};